import React from 'react';
import { Button } from '../../components/ui/button';
import { motion } from 'framer-motion';
import {
  Bot,
  Plus,
  Trash2,
  RefreshCw,
  MessageSquare,
} from 'lucide-react';

export const BotTab = ({
  isItalian,
  botPhrases,
  loadingPhrases,
  setShowAddPhraseDialog,
  handleDeletePhrase,
  handleSeedBotPhrases,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="bg-[#0a0d15] border border-white/10"
    >
      <div className="p-4 border-b border-white/10 flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Bot size={20} className="text-[#FFEA00]" />
          <h3 className="font-heading text-lg uppercase tracking-wider text-white">
            {isItalian ? 'Frasi Bot Chat' : 'Chat Bot Phrases'}
          </h3>
        </div>
        <div className="flex gap-3">
          <Button
            onClick={handleSeedBotPhrases}
            variant="outline"
            className="border-[#00F0FF] text-[#00F0FF] hover:bg-[#00F0FF]/10"
            size="sm"
          >
            <RefreshCw size={14} className="mr-2" />
            {isItalian ? 'Carica Default' : 'Load Defaults'}
          </Button>
          <Button
            onClick={() => setShowAddPhraseDialog(true)}
            className="bg-[#00E676] hover:bg-[#00E676]/90 text-black font-bold"
            size="sm"
          >
            <Plus size={14} className="mr-2" />
            {isItalian ? 'Nuova Frase' : 'New Phrase'}
          </Button>
        </div>
      </div>

      <div className="p-4">
        <p className="text-sm text-slate-400 mb-4">
          {isItalian
            ? 'Usa {gamertag} nella frase per inserire il nome del giocatore. Es: "Ciao {gamertag}!"'
            : 'Use {gamertag} in the phrase to insert the player name. E.g., "Hello {gamertag}!"'}
        </p>

        {loadingPhrases ? (
          <div className="flex items-center justify-center py-8">
            <div className="animate-spin w-8 h-8 border-2 border-[#FFEA00] border-t-transparent rounded-full" />
          </div>
        ) : botPhrases.length === 0 ? (
          <div className="text-center py-12">
            <MessageSquare size={48} className="mx-auto text-slate-600 mb-4" />
            <p className="text-slate-400">
              {isItalian ? 'Nessuna frase configurata. Clicca "Carica Default" per iniziare.' : 'No phrases configured. Click "Load Defaults" to start.'}
            </p>
          </div>
        ) : (
          <div className="space-y-3">
            {botPhrases.map((phrase) => (
              <div
                key={phrase.phrase_id}
                className="flex items-center justify-between p-3 bg-[#050508] border border-white/10"
              >
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="px-2 py-0.5 bg-[#FFEA00]/20 text-[#FFEA00] text-xs font-mono rounded">
                      {phrase.command}
                    </span>
                  </div>
                  <p className="text-white text-sm">{phrase.phrase}</p>
                </div>
                <Button
                  onClick={() => handleDeletePhrase(phrase.phrase_id)}
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8 text-red-400 hover:text-red-300 hover:bg-red-500/10"
                >
                  <Trash2 size={14} />
                </Button>
              </div>
            ))}
          </div>
        )}
      </div>
    </motion.div>
  );
};
